export var SubOrderSummaryGroupText;
(function (SubOrderSummaryGroupText) {
    SubOrderSummaryGroupText["TITLE_PAST_CUTOFF"] = "Past Cutoff Orders";
    SubOrderSummaryGroupText["TOOLTIP_PAST_CUTOFF"] = "These orders can not be canceled and you will still receive {meal_entity_name_plural}.";
    SubOrderSummaryGroupText["TITLE_UPCOMING"] = "Upcoming Orders";
    SubOrderSummaryGroupText["TOOLTIP_UPCOMING"] = "Renewal orders may be kept, but future orders will be canceled.";
    // Used on Edit Flow
    SubOrderSummaryGroupText["TITLE_ACTIVE"] = "Active and Future Orders";
    SubOrderSummaryGroupText["TOOLTIP_PAST_CUTOFF_UPDATE"] = "These orders can not be updated.";
    SubOrderSummaryGroupText["TOOLTIP_UPDATE_ACTIVE"] = "Active and Future orders can be updated.";
    SubOrderSummaryGroupText["ACTIVE_ORDERS_WARNING"] = "Your subscription changes will only apply to the orders you have selected.";
    SubOrderSummaryGroupText["CONFIRM_CHANGES_CHECKBOX_LABEL"] = "I understand that only the selected orders will be updated with my subscription changes.";
})(SubOrderSummaryGroupText || (SubOrderSummaryGroupText = {}));
export var MyMealsQuantitySelectionMode;
(function (MyMealsQuantitySelectionMode) {
    MyMealsQuantitySelectionMode[MyMealsQuantitySelectionMode["NoChanges"] = 0] = "NoChanges";
    MyMealsQuantitySelectionMode[MyMealsQuantitySelectionMode["DiscreteChanges"] = 10] = "DiscreteChanges";
    MyMealsQuantitySelectionMode[MyMealsQuantitySelectionMode["AdHocChanges"] = 20] = "AdHocChanges";
})(MyMealsQuantitySelectionMode || (MyMealsQuantitySelectionMode = {}));
/**
 * ProductAndRecipeCardLayoutSettings['DisplayNameType']
 */
export var DisplayNameType;
(function (DisplayNameType) {
    DisplayNameType[DisplayNameType["ShortName"] = 0] = "ShortName";
    DisplayNameType[DisplayNameType["LongName"] = 10] = "LongName";
})(DisplayNameType || (DisplayNameType = {}));
/**
 * ProductAndRecipeCardLayoutSettings['ImageDisplayMode']
 */
export var ImageDisplayMode;
(function (ImageDisplayMode) {
    ImageDisplayMode[ImageDisplayMode["DetailsOverlay"] = 0] = "DetailsOverlay";
    ImageDisplayMode[ImageDisplayMode["ImagePinnedTop"] = 10] = "ImagePinnedTop";
    ImageDisplayMode[ImageDisplayMode["NoImage"] = 20] = "NoImage";
})(ImageDisplayMode || (ImageDisplayMode = {}));
/**
 * CouponApplyViewModel['DiscountValidationType']
 */
export var DiscountValidationType;
(function (DiscountValidationType) {
    DiscountValidationType[DiscountValidationType["Invalid"] = 0] = "Invalid";
    DiscountValidationType[DiscountValidationType["Expired"] = 10] = "Expired";
    DiscountValidationType[DiscountValidationType["Used"] = 20] = "Used";
    DiscountValidationType[DiscountValidationType["First_Order_Only"] = 30] = "First_Order_Only";
    DiscountValidationType[DiscountValidationType["Subscriptions_Only"] = 40] = "Subscriptions_Only";
    DiscountValidationType[DiscountValidationType["Trials_Only"] = 50] = "Trials_Only";
    DiscountValidationType[DiscountValidationType["Below_Min_Cost"] = 60] = "Below_Min_Cost";
    DiscountValidationType[DiscountValidationType["Valid"] = 70] = "Valid";
})(DiscountValidationType || (DiscountValidationType = {}));
export var SubscriptionStatusValues;
(function (SubscriptionStatusValues) {
    SubscriptionStatusValues["ACTIVE"] = "Active";
    SubscriptionStatusValues["PAUSED"] = "Paused";
    SubscriptionStatusValues["CANCELLED"] = "Cancelled";
    SubscriptionStatusValues["COMPLETE"] = "Complete";
    SubscriptionStatusValues["NONE"] = "None";
})(SubscriptionStatusValues || (SubscriptionStatusValues = {}));
